import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Dropdown,
  Button,
  Segment,
  Grid,
  Divider,
  Form,
  Modal,
  Popup,
  Icon,
  Dimmer,
  Loader,
  Image,
  Header,
  Accordion,
  Label
} from "semantic-ui-react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

var cursorBACount = 0;
var cursorABCount = 0;
let selectedAddress = 0;

export class Oscilloscope extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAutomaticCheckboxChecked: true,
      isDimmerActive: false,
      isRefenceImageModalOpen: false,

      oscilloscopeData: [],

      devices: [],
      wave: [],
      selectedDropdownAddress: -1,

      timeCursorBAValues: [],
      voltageCursorBAValues: [],

      timeCursorABValues: [],
      voltageCursorABValues: [],

      cursorTimeUnit: Strings.MICROSSECOND,

      playButtonColor: "grey",
      pauseButtonColor: "grey",

      amplitudeActive: false,
      timeActive: false,

      seriesBA: [{ data: [] }],
      seriesAB: [{ data: [] }],

      optionsBA: {
        tooltip: {
          enabled: true,
          intersect: false,
          shared: false,
          onDatasetHover: {
            highlightDataSeries: true,
          },
          x: {
            show: true,
            formatter: function (val) {
              const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

              if (lang !== Constants.EN_LANG_KEY) {
                return Strings.TIME_DP + UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.NANOSSECOND;
              }
              else {
                return Strings.TIME_DP + val.toFixed(2) + Strings.NANOSSECOND;
              }
            },
          },
        },
        chart: {
          id: Constants.OSCILLOSCOPE_CHART_ID,
          type: "line",
          locales: [
            {
              name: "pt-br",
              options: {
                months: [
                  "Janeiro",
                  "Fevereiro",
                  "Março",
                  "Abril",
                  "Maio",
                  "Junho",
                  "Julho",
                  "Agosto",
                  "Setembro",
                  "Outubro",
                  "Novembro",
                  "Dezembro",
                ],
                shortMonths: [
                  "Jan",
                  "Fev",
                  "Mar",
                  "Abr",
                  "Mai",
                  "Jun",
                  "Jul",
                  "Ago",
                  "Set",
                  "Out",
                  "Nov",
                  "Dez",
                ],
                days: [
                  "Domingo",
                  "Segunda",
                  "Terça",
                  "Quarta",
                  "Quinta",
                  "Sexta",
                  "Sábado",
                ],
                shortDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
                toolbar: {
                  exportToSVG: "Baixar SVG",
                  exportToPNG: "Baixar PNG",
                  exportToCSV: "Baixar CSV",
                  menu: "Baixar",
                  selection: "Selecionar",
                  selectionZoom: "Selecionar Zoom",
                  zoomIn: "Aumentar",
                  zoomOut: "Diminuir",
                  pan: "Navegação",
                  reset: "Reiniciar Zoom",
                },
              },
            },
          ],
          defaultLocale: "pt-br",
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            show: false,
            autoSelected: "reset",
            tools: {
              download: this.getDownloadImgPath(),
            },
          },
          animations: {
            enabled: false,
            easing: "linear",
            speed: 500,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
          events: {
            click: (event, chartContext, config) => {
              if (this.state.amplitudeActive) {
                this.addYAxisAnnotationBA(
                  config.dataPointIndex,
                  config.seriesIndex
                );
              } else if (this.state.timeActive) {
                this.addXAxisAnnotationBA(config.dataPointIndex);
              }
            },
            scrolled: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false,
                });

                this.clearAllAnnotations();
              }
            },
            selection: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false,
                });

                this.clearAllAnnotations();
              }
            },
            zoomed: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false,
                });

                this.clearAllAnnotations();
              }
            },
          },
        },
        colors: [Constants.PURPLE_HEX],
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
          width: 2,
        },
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS,
          },
          crosshairs: {
            show: "true",
          },
          tooltip: {
            enabled: false,
          },
          labels: {
            show: true,
            formatter: function (value) {
              const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

              if (value !== undefined && value < 10) {
                return (lang !== Constants.EN_LANG_KEY) ? UtilsInstance.replacePointWithComma(value.toFixed(2)) : value.toFixed(2);
              }
              else if (value !== undefined && value >= 10) {
                return value.toFixed(0);
              }
              else {
                return value;
              }
            },
          },
        },
        yaxis: {
          min: -5,
          max: 5,
          tickAmount: 10,
          labels: {
            formatter: function (val) {
              const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

              if (lang !== Constants.EN_LANG_KEY) {
                return UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.VOLTAGE_PEAK_TO_PEAK;
              }
              else {
                return val.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK;
              }
            },
          },
          title: {
            text: Strings.VOLTAGE_V,
          },
        },
        annotations: {
          position: "front",
          xaxis: [],
        },
      },

      optionsAB: {
        tooltip: {
          enabled: true,
          intersect: false,
          shared: false,
          onDatasetHover: {
            highlightDataSeries: true,
          },
          x: {
            show: true,
            formatter: function (val) {
              const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

              if (lang !== Constants.EN_LANG_KEY) {
                return Strings.TIME_DP + UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.NANOSSECOND;
              }
              else {
                return Strings.TIME_DP + val.toFixed(2) + Strings.NANOSSECOND;
              }
            },
          },
        },
        chart: {
          id: Constants.OSCILLOSCOPE_CHART_ID_AB,
          type: "line",
          locales: [
            {
              name: "pt-br",
              options: {
                months: [
                  "Janeiro",
                  "Fevereiro",
                  "Março",
                  "Abril",
                  "Maio",
                  "Junho",
                  "Julho",
                  "Agosto",
                  "Setembro",
                  "Outubro",
                  "Novembro",
                  "Dezembro",
                ],
                shortMonths: [
                  "Jan",
                  "Fev",
                  "Mar",
                  "Abr",
                  "Mai",
                  "Jun",
                  "Jul",
                  "Ago",
                  "Set",
                  "Out",
                  "Nov",
                  "Dez",
                ],
                days: [
                  "Domingo",
                  "Segunda",
                  "Terça",
                  "Quarta",
                  "Quinta",
                  "Sexta",
                  "Sábado",
                ],
                shortDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
                toolbar: {
                  exportToSVG: "Baixar SVG",
                  exportToPNG: "Baixar PNG",
                  exportToCSV: "Baixar CSV",
                  menu: "Baixar",
                  selection: "Selecionar",
                  selectionZoom: "Selecionar Zoom",
                  zoomIn: "Aumentar",
                  zoomOut: "Diminuir",
                  pan: "Navegação",
                  reset: "Reiniciar Zoom",
                },
              },
            },
          ],
          defaultLocale: "pt-br",
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            show: false,
            autoSelected: "reset",
            tools: {
              download: this.getDownloadImgPath(),
            },
          },
          animations: {
            enabled: false,
            easing: "linear",
            speed: 500,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
          events: {
            click: (event, chartContext, config) => {
              if (this.state.amplitudeActive) {
                this.addYAxisAnnotationAB(
                  config.dataPointIndex,
                  config.seriesIndex
                );
              } else if (this.state.timeActive) {
                this.addXAxisAnnotationAB(config.dataPointIndex);
              }
            },
            scrolled: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false,
                });

                this.clearAllAnnotations();
              }
            },
            selection: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false,
                });

                this.clearAllAnnotations();
              }
            },
            zoomed: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false,
                });

                this.clearAllAnnotations();
              }
            },
          },
        },
        colors: [Constants.GREEN_HEX, Constants.RED_HEX],
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
          width: 2,
        },
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS,
          },
          crosshairs: {
            show: "true",
          },
          tooltip: {
            enabled: false,
          },
          labels: {
            show: true,
            formatter: function (value) {
              const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

              if (value !== undefined && value < 10) {
                return (lang !== Constants.EN_LANG_KEY) ? UtilsInstance.replacePointWithComma(value.toFixed(2)) : value.toFixed(2);
              }
              else if (value !== undefined && value >= 10) {
                return value.toFixed(0);
              }
              else {
                return value;
              }
            },
          },
        },
        yaxis: {
          min: -5,
          max: 5,
          tickAmount: 10,
          labels: {
            formatter: function (val) {
              const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

              if (lang !== Constants.EN_LANG_KEY) {
                return UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.VOLTAGE_PEAK_TO_PEAK;
              }
              else {
                return val.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK;
              }
            },
          },
          title: {
            text: Strings.VOLTAGE_V,
          },
        },
        annotations: {
          position: "front",
          xaxis: [],
        },
      },

      errorMessages: [],
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController()
    };
  }

  getDownloadImgPath = () => {
    // eslint-disable-next-line quotes
    return `<img src="${process.env.PUBLIC_URL}/images/down-arrow.svg" height="18" style="margin-left: 5px;" />`;
  };

  retrieveData = () => {
    this.setDimmerActiveState(true);
    // Get livelist data
    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS, { mode: "cors", signal: this.state.controller.signal })
      .then((res) => res.json())
      .then((data) =>
        this.setState(
          {
            devices: data.sort(
              UtilsInstance.sortBy("address", false, parseInt)
            ),
          },
          () => {
            this.startAutoVisualization();
          }
        )
      )
      .catch((error) => {
        console.log("Warnings interrupted: ", error);
      });
  };

  formatWaveTimes = (wave) => {
    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds
      // (it already is by default, so do nothing here)
    } else if (
      wave[wave.length - 1][0] >= 1000 &&
      wave[wave.length - 1][0] < 1000000
    ) {
      // Set the time values to microsseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / 10 ** 3;
      }
    } else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / 10 ** 6;
      }
    }

    return wave;
  };

  getFormatedOptions = (wave, deviceAddress, hasWaveProblem, isBAWave) => {
    let options = {};
    let subtitleText = "";

    if (hasWaveProblem) {
      subtitleText =
        Strings.SLAVE_NOT_FOUND_SHOWING_LAST_WAVEFORM;
    }

    if (isBAWave) {
      if (wave[wave.length - 1][0] < 1000) {
        // Set the time values to nanosseconds
        options = {
          ...this.state.optionsBA,
          tooltip: {
            enabled: true,
            intersect: false,
            shared: false,
            onDatasetHover: {
              highlightDataSeries: true,
            },
            x: {
              show: true,
              formatter: function (val) {
                const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

                if (lang !== Constants.EN_LANG_KEY) {
                  return Strings.TIME_DP + UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.NANOSSECOND;
                }
                else {
                  return Strings.TIME_DP + val.toFixed(2) + Strings.NANOSSECOND;
                }
              },
            },
          },
          xaxis: {
            type: "numeric",
            title: {
              text: Strings.TIME_NS,
            },
            crosshairs: {
              show: "true",
            },
            tooltip: {
              enabled: false,
            },
          },
          title: {
            text: Strings.ADDRESS_DP + deviceAddress,
            align: "center",
          },
          subtitle: {
            text: subtitleText,
            align: "center",
          },
        };

        this.setState({ cursorTimeUnit: Strings.NANOSSECOND });
      } else if (
        wave[wave.length - 1][0] >= 1000 &&
        wave[wave.length - 1][0] < 1000000
      ) {
        // Set the time values to microsseconds
        options = {
          ...this.state.optionsBA,
          tooltip: {
            enabled: true,
            intersect: false,
            shared: false,
            onDatasetHover: {
              highlightDataSeries: true,
            },
            x: {
              show: true,
              formatter: function (val) {
                const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

                if (lang !== Constants.EN_LANG_KEY) {
                  return Strings.TIME_DP + UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.MICROSSECOND;
                }
                else {
                  return Strings.TIME_DP + val.toFixed(2) + Strings.MICROSSECOND;
                }
              },
            },
          },
          xaxis: {
            type: "numeric",
            title: {
              text: Strings.TIME_US,
            },
            crosshairs: {
              show: "true",
            },
            tooltip: {
              enabled: false,
            },
          },
          title: {
            text: Strings.ADDRESS_DP + deviceAddress,
            align: "center",
          },
          subtitle: {
            text: subtitleText,
            align: "center",
          },
        };

        this.setState({ cursorTimeUnit: Strings.MICROSSECOND });
      } else if (wave[wave.length - 1][0] >= 1000000) {
        // Set the time values to millisseconds
        options = {
          ...this.state.optionsBA,
          tooltip: {
            enabled: true,
            intersect: false,
            shared: false,
            onDatasetHover: {
              highlightDataSeries: true,
            },
            x: {
              show: true,
              formatter: function (val) {
                const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

                if (lang !== Constants.EN_LANG_KEY) {
                  return Strings.TIME_DP + UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.MILLISSECOND;
                }
                else {
                  return Strings.TIME_DP + val.toFixed(2) + Strings.MILLISSECOND;
                }
              },
            },
          },
          xaxis: {
            type: "numeric",
            title: {
              text: Strings.TIME_MS,
            },
            crosshairs: {
              show: "true",
            },
            tooltip: {
              enabled: false,
            },
          },
          title: {
            text: Strings.ADDRESS_DP + deviceAddress,
            align: "center",
          },
          subtitle: {
            text: subtitleText,
            align: "center",
          },
        };

        this.setState({ cursorTimeUnit: Strings.MILLISSECOND });
      }

      options.colors = [Constants.PURPLE_HEX];
    } else {
      if (wave[wave.length - 1][0] < 1000) {
        // Set the time values to nanosseconds
        options = {
          ...this.state.optionsAB,
          tooltip: {
            enabled: true,
            intersect: false,
            shared: false,
            onDatasetHover: {
              highlightDataSeries: true,
            },
            x: {
              show: true,
              formatter: function (val) {
                const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

                if (lang !== Constants.EN_LANG_KEY) {
                  return Strings.TIME_DP + UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.NANOSSECOND;
                }
                else {
                  return Strings.TIME_DP + val.toFixed(2) + Strings.NANOSSECOND;
                }
              },
            },
          },
          xaxis: {
            type: "numeric",
            title: {
              text: Strings.TIME_NS,
            },
            crosshairs: {
              show: "true",
            },
            tooltip: {
              enabled: false,
            },
          },
        };

        this.setState({ cursorTimeUnit: Strings.NANOSSECOND });
      } else if (
        wave[wave.length - 1][0] >= 1000 &&
        wave[wave.length - 1][0] < 1000000
      ) {
        // Set the time values to microsseconds
        options = {
          ...this.state.optionsAB,
          tooltip: {
            enabled: true,
            intersect: false,
            shared: false,
            onDatasetHover: {
              highlightDataSeries: true,
            },
            x: {
              show: true,
              formatter: function (val) {
                const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

                if (lang !== Constants.EN_LANG_KEY) {
                  return Strings.TIME_DP + UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.MICROSSECOND;
                }
                else {
                  return Strings.TIME_DP + val.toFixed(2) + Strings.MICROSSECOND;
                }
              },
            },
          },
          xaxis: {
            type: "numeric",
            title: {
              text: Strings.TIME_US,
            },
            crosshairs: {
              show: "true",
            },
            tooltip: {
              enabled: false,
            },
          },
        };

        this.setState({ cursorTimeUnit: Strings.MICROSSECOND });
      } else if (wave[wave.length - 1][0] >= 1000000) {
        // Set the time values to millisseconds
        options = {
          ...this.state.optionsAB,
          tooltip: {
            enabled: true,
            intersect: false,
            shared: false,
            onDatasetHover: {
              highlightDataSeries: true,
            },
            x: {
              show: true,
              formatter: function (val) {
                const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

                if (lang !== Constants.EN_LANG_KEY) {
                  return Strings.TIME_DP + UtilsInstance.replacePointWithComma(val.toFixed(2)) + Strings.MILLISSECOND;
                }
                else {
                  return Strings.TIME_DP + val.toFixed(2) + Strings.MILLISSECOND;
                }
              },
            },
          },
          xaxis: {
            type: "numeric",
            title: {
              text: Strings.TIME_MS,
            },
            crosshairs: {
              show: "true",
            },
            tooltip: {
              enabled: false,
            },
          },
        };

        this.setState({ cursorTimeUnit: Strings.MILLISSECOND });
      }

      options.colors = [Constants.GREEN_HEX, Constants.RED_HEX];
    }

    return options;
  };

  getSizeImage = () => {
    return <Image src={`${process.env.PUBLIC_URL}/images/size_desc_img.png`} />;
  };

  // --------------- Dropdown Methods -------------------------------
  buildDevicesDropdownOptions = (devices) => {
    let dropdownMap = devices.map((device) => ({
      key: device.address,
      text: Strings.ADDRESS_DP + device.address,
      value: device.address,
    }));

    return dropdownMap;
  };

  onDevicesDropdownChange = (e, { value }) => {
    this.setState(
      {
        selectedDropdownAddress: value,
        playButtonColor: "grey",
        pauseButtonColor: "red",
      },
      () => {
        clearInterval(this.state.intervalID);
        this.getWaveData(this.state.selectedDropdownAddress);
        this.clearAllAnnotations();
        this.setDisabledButtonsState(false, false, false, false);
      }
    );
  };

  // ---------------- Get the wave data of the choosen device ----------------

  getWaveData = async (deviceAddress) => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "oscilloscopeWaves3byte/" + deviceAddress, {
        mode: "cors",
        signal: this.state.controller.signal
      })
        .then((res) => res.json())
        .then((data) => data)
        .catch((error) => {
          console.log("oscilloscopeWaves3byte/ interrupted: ", error);
          return "";
        })
    );

    promissesArray.push(
      fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "liveList/" + deviceAddress, {
        mode: "cors",
        signal: this.state.controller.signal
      })
        .then((res) => res.json())
        .then((data) => data)
        .catch((error) => {
          console.log("liveList/ interrupted: ", error);
          return "";
        })
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    if (resolvedPromisses[0] !== "" && resolvedPromisses[1] !== "") {

      let shouldUpdate = resolvedPromisses[0][0].update;
      let oscilloscopeBAData = resolvedPromisses[0][0].wave;
      let oscilloscopeAData = resolvedPromisses[0][0].waveA;
      let oscilloscopeBData = resolvedPromisses[0][0].waveB;
      let hasWaveProblem = resolvedPromisses[1][0].hasWaveProblem;

      // console.log("1: ", oscilloscopeBAData);
      // console.log("2: ", oscilloscopeAData);
      // console.log("3: ", oscilloscopeBData);
      // console.log("4: ", shouldUpdate);

      if (
        oscilloscopeBAData !== undefined &&
        oscilloscopeAData !== undefined &&
        oscilloscopeBData !== undefined &&
        shouldUpdate
      ) {

        let optionsBA = this.getFormatedOptions(
          oscilloscopeBAData,
          deviceAddress,
          hasWaveProblem,
          true
        );

        let optionsAB = this.getFormatedOptions(
          oscilloscopeAData,
          deviceAddress,
          hasWaveProblem,
          false
        );

        let waveBAData = this.formatWaveTimes(oscilloscopeBAData);
        let waveAData = this.formatWaveTimes(oscilloscopeAData);
        let waveBData = this.formatWaveTimes(oscilloscopeBData);

        this.setState({
          optionsBA: optionsBA,
          optionsAB: optionsAB,
          seriesBA: [
            {
              name: Strings.WAVE_B_A,
              data: waveBAData,
            },
          ],
          seriesAB: [
            {
              name: Strings.WAVE_A,
              data: waveAData,
            },
            {
              name: Strings.WAVE_B,
              data: waveBData,
            },
          ],
        });
      }
      // If data for this deviceAddress doesn't exist, set the data as an empty array
      else {
        this.setState({
          seriesBA: [{ name: Strings.WAVE_B_A, data: [] }],
          seriesAB: [
            { name: Strings.WAVE_A, data: [] },
            { name: Strings.WAVE_B, data: [] },
          ],
        });
      }
    }

  };

  // ---------------------- Control Buttons ----------------------
  handlePlayButtonClick = () => {
    if (this.state.playButtonColor !== "green") {
      let intervalID = -1;

      // First clear all annotations
      this.clearAllAnnotations();

      this.getWaveData(this.state.selectedDropdownAddress);
      intervalID = setInterval(() => {
        this.getWaveData(this.state.selectedDropdownAddress);
      }, Constants.PLAY_REFRESH_INTERVAL_MS);

      // And change the color of the buttons
      this.setDisabledButtonsState(false, false, true, true);

      this.setState({
        intervalID: intervalID,
        playButtonColor: "green",
        pauseButtonColor: "grey",
      });
    }
  };

  handlePauseButtonClick = () => {
    // Stop the data refresh
    clearInterval(this.state.intervalID);

    this.setDisabledButtonsState(false, false, false, false);

    this.setState({
      playButtonColor: "grey",
      pauseButtonColor: "red",
    });
  };

  // ---------------------- Cursor Buttons  ----------------------
  handleAmplitudeButtonClick = () => {
    this.setState({
      amplitudeActive: !this.state.amplitudeActive,
      timeActive: false,
    });

    this.clearAllAnnotations();
  };

  handleTimeButtonClick = () => {
    this.setState({
      timeActive: !this.state.timeActive,
      amplitudeActive: false,
    });

    this.clearAllAnnotations();
  };

  // ---------------------- Button States ----------------------
  setDisabledButtonsState = (
    playState,
    pauseState,
    amplitudeState,
    timeState
  ) => {
    document.getElementById("play-btn").disabled = playState;
    document.getElementById("pause-btn").disabled = pauseState;
    document.getElementById("amplitude-btn").disabled = amplitudeState;
    document.getElementById("time-interval-btn").disabled = timeState;
  };

  // --------------- Cursors Methods -------------------------------
  clearBAAnnotations = () => {
    // Ask ApexCharts to clear the cursors from screen
    ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");

    // Reset the cursors values arrays
    this.setState({
      timeCursorBAValues: [],
      voltageCursorBAValues: [],
    });

    // Set the cursors calculation texts back to default
    document.getElementById("time-interval").innerText =
      Strings.TIME_INTERVAL_PLACEHOLDER + this.state.cursorTimeUnit;
    document.getElementById("wave-amplitude").innerText =
      Strings.AMPLITUDE_PLACEHOLDER;

    // Finally reset the number of active cursors back to 0
    cursorBACount = 0;
  };

  clearABAnnotations = () => {
    // Ask ApexCharts to clear the cursors from screen
    ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID_AB, "clearAnnotations");

    // Reset the cursors values arrays
    this.setState({
      timeCursorABValues: [],
      voltageCursorABValues: [],
    });

    // Set the cursors calculation texts back to default
    document.getElementById("time-interval").innerText =
      Strings.TIME_INTERVAL_PLACEHOLDER + this.state.cursorTimeUnit;
    document.getElementById("wave-amplitude").innerText =
      Strings.AMPLITUDE_PLACEHOLDER;

    // Finally reset the number of active cursors back to 0
    cursorABCount = 0;
  };

  clearAllAnnotations = () => {
    // Ask ApexCharts to clear the cursors from screen
    ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");
    ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID_AB, "clearAnnotations");

    // Reset the cursors values arrays
    this.setState({
      timeCursorBAValues: [],
      timeCursorABValues: [],
      voltageCursorBAValues: [],
      voltageCursorABValues: [],
    });

    // Set the cursors calculation texts back to default
    document.getElementById("time-interval").innerText =
      Strings.TIME_INTERVAL_PLACEHOLDER + this.state.cursorTimeUnit;
    document.getElementById("wave-amplitude").innerText =
      Strings.AMPLITUDE_PLACEHOLDER;

    // Finally reset the number of active cursors back to 0
    cursorBACount = 0;
    cursorABCount = 0;
  };

  addXAxisAnnotationBA = (dataPointIndex) => {
    // Only let the user set time cursors if the button is enabled
    if (!document.getElementById("time-interval-btn").disabled) {
      let timeCursorValuesCopy = this.state.timeCursorBAValues;

      // If the user has clicked on the first point, draw the cursor there
      if (dataPointIndex !== -1 && cursorBACount === 0) {
        timeCursorValuesCopy.push(
          this.state.seriesBA[0].data[dataPointIndex][0]
        );

        this.setState({ timeCursorBAValues: timeCursorValuesCopy }, () => {
          ApexCharts.exec(
            Constants.OSCILLOSCOPE_CHART_ID,
            "addXaxisAnnotation",
            {
              x: this.state.timeCursorBAValues[0],
              strokeDashArray: 0,
              borderColor: Constants.TEAL_HEX,
            }
          );

          cursorBACount++;
        });
      }
      // If it is the second point draw a range cursor
      else if (dataPointIndex !== -1 && cursorBACount === 1) {
        ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");

        timeCursorValuesCopy.push(
          this.state.seriesBA[0].data[dataPointIndex][0]
        );

        this.setState({ timeCursorBAValues: timeCursorValuesCopy }, () => {
          ApexCharts.exec(
            Constants.OSCILLOSCOPE_CHART_ID,
            "addXaxisAnnotation",
            {
              x: this.state.timeCursorBAValues[0],
              x2: this.state.timeCursorBAValues[1],
              strokeDashArray: 0,
              fillColor: Constants.TEAL_HEX,
              opacity: 0.4,
              borderColor: Constants.TEAL_HEX,
            }
          );

          let timeInterval = Math.abs(
            this.state.timeCursorBAValues[0] - this.state.timeCursorBAValues[1]
          );
          document.getElementById("time-interval").innerText =
            timeInterval.toFixed(2) + this.state.cursorTimeUnit;

          cursorBACount++;
        });
      }
      // If the user clicks on a dataPoint for a third time, clear the cursors
      else if (dataPointIndex !== -1 && cursorBACount === 2) {
        this.clearBAAnnotations();
      }
    }
  };

  addYAxisAnnotationBA = (dataPointIndex, seriesIndex) => {
    // Only let the user set amplitude cursors if the button is enabled
    if (!document.getElementById("amplitude-btn").disabled) {
      let voltageCursorValuesCopy = this.state.voltageCursorBAValues;

      // If the user has clicked on the first point, draw the cursor there
      if (dataPointIndex !== -1 && cursorBACount === 0) {
        voltageCursorValuesCopy.push(
          this.state.seriesBA[seriesIndex].data[dataPointIndex][1]
        );

        this.setState({ voltageCursorBAValues: voltageCursorValuesCopy }, () => {
          ApexCharts.exec(
            Constants.OSCILLOSCOPE_CHART_ID,
            "addYaxisAnnotation",
            {
              y: this.state.voltageCursorBAValues[0],
              yAxisIndex: 0,
              strokeDashArray: 0,
              borderColor: Constants.TEAL_HEX,
            }
          );
        });

        cursorBACount++;
      }
      // If it is the second point draw a range cursor
      else if (dataPointIndex !== -1 && cursorBACount === 1) {
        ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");

        voltageCursorValuesCopy.push(
          this.state.seriesBA[seriesIndex].data[dataPointIndex][1]
        );

        this.setState({ voltageCursorBAValues: voltageCursorValuesCopy }, () => {
          ApexCharts.exec(
            Constants.OSCILLOSCOPE_CHART_ID,
            "addYaxisAnnotation",
            {
              y: this.state.voltageCursorBAValues[0],
              y2: this.state.voltageCursorBAValues[1],
              strokeDashArray: 0,
              fillColor: Constants.TEAL_HEX,
              opacity: 0.4,
              borderColor: Constants.TEAL_HEX,
            }
          );

          let amplitude = Math.abs(
            this.state.voltageCursorBAValues[0] -
            this.state.voltageCursorBAValues[1]
          );
          document.getElementById("wave-amplitude").innerText =
            amplitude.toFixed(2) + Strings.VOLTAGE;

          cursorBACount++;
        });
      }
      // If the user clicks on a dataPoint for a third time, clear the cursors
      else if (cursorBACount === 2) {
        this.clearBAAnnotations();
      }
    }
  };

  addXAxisAnnotationAB = (dataPointIndex) => {
    // Only let the user set time cursors if the button is enabled
    if (!document.getElementById("time-interval-btn").disabled) {
      let timeCursorValuesCopy = this.state.timeCursorABValues;

      // If the user has clicked on the first point, draw the cursor there
      if (dataPointIndex !== -1 && cursorABCount === 0) {
        timeCursorValuesCopy.push(
          this.state.seriesAB[0].data[dataPointIndex][0]
        );

        this.setState({ timeCursorABValues: timeCursorValuesCopy }, () => {
          ApexCharts.exec(
            Constants.OSCILLOSCOPE_CHART_ID_AB,
            "addXaxisAnnotation",
            {
              x: this.state.timeCursorABValues[0],
              strokeDashArray: 0,
              borderColor: Constants.TEAL_HEX,
            }
          );

          cursorABCount++;
        });
      }
      // If it is the second point draw a range cursor
      else if (dataPointIndex !== -1 && cursorABCount === 1) {
        ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID_AB, "clearAnnotations");

        timeCursorValuesCopy.push(
          this.state.seriesAB[0].data[dataPointIndex][0]
        );

        this.setState({ timeCursorABValues: timeCursorValuesCopy }, () => {
          ApexCharts.exec(
            Constants.OSCILLOSCOPE_CHART_ID_AB,
            "addXaxisAnnotation",
            {
              x: this.state.timeCursorABValues[0],
              x2: this.state.timeCursorABValues[1],
              strokeDashArray: 0,
              fillColor: Constants.TEAL_HEX,
              opacity: 0.4,
              borderColor: Constants.TEAL_HEX,
            }
          );

          let timeInterval = Math.abs(
            this.state.timeCursorABValues[0] - this.state.timeCursorABValues[1]
          );
          document.getElementById("time-interval").innerText =
            timeInterval.toFixed(2) + this.state.cursorTimeUnit;

          cursorABCount++;
        });
      }
      // If the user clicks on a dataPoint for a third time, clear the cursors
      else if (dataPointIndex !== -1 && cursorABCount === 2) {
        this.clearABAnnotations();
      }
    }
  };

  addYAxisAnnotationAB = (dataPointIndex, seriesIndex) => {
    // Only let the user set amplitude cursors if the button is enabled
    if (!document.getElementById("amplitude-btn").disabled) {
      let voltageCursorValuesCopy = this.state.voltageCursorABValues;

      // If the user has clicked on the first point, draw the cursor there
      if (dataPointIndex !== -1 && cursorABCount === 0) {
        voltageCursorValuesCopy.push(
          this.state.seriesAB[seriesIndex].data[dataPointIndex][1]
        );

        this.setState({ voltageCursorABValues: voltageCursorValuesCopy }, () => {
          ApexCharts.exec(
            Constants.OSCILLOSCOPE_CHART_ID_AB,
            "addYaxisAnnotation",
            {
              y: this.state.voltageCursorABValues[0],
              yAxisIndex: 0,
              strokeDashArray: 0,
              borderColor: Constants.TEAL_HEX,
            }
          );
        });

        cursorABCount++;
      }
      // If it is the second point draw a range cursor
      else if (dataPointIndex !== -1 && cursorABCount === 1) {
        ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID_AB, "clearAnnotations");

        voltageCursorValuesCopy.push(
          this.state.seriesAB[seriesIndex].data[dataPointIndex][1]
        );

        this.setState({ voltageCursorABValues: voltageCursorValuesCopy }, () => {
          ApexCharts.exec(
            Constants.OSCILLOSCOPE_CHART_ID_AB,
            "addYaxisAnnotation",
            {
              y: this.state.voltageCursorABValues[0],
              y2: this.state.voltageCursorABValues[1],
              strokeDashArray: 0,
              fillColor: Constants.TEAL_HEX,
              opacity: 0.4,
              borderColor: Constants.TEAL_HEX,
            }
          );

          let amplitude = Math.abs(
            this.state.voltageCursorABValues[0] -
            this.state.voltageCursorABValues[1]
          );
          document.getElementById("wave-amplitude").innerText =
            amplitude.toFixed(2) + Strings.VOLTAGE;

          cursorABCount++;
        });
      }
      // If the user clicks on a dataPoint for a third time, clear the cursors
      else if (cursorABCount === 2) {
        this.clearABAnnotations();
      }
    }
  };

  setDimmerActiveState = (state) => {
    this.setState({ isDimmerActive: state });
  };

  /// ---------------- Visualization Type -----------------------------
  handleVisualizationTypeCheckboxChange = (e, { value }) => {
    this.setState(
      {
        isAutomaticCheckboxChecked: value === Constants.AUTOMATIC_CHECKBOX_VAL,
      },
      () => {
        clearInterval(this.state.intervalID);

        if (this.state.isAutomaticCheckboxChecked) {
          this.setState(
            {
              selectedDropdownAddress: -1,
              playButtonColor: "grey",
              pauseButtonColor: "red",
            },
            () => {
              this.setDisabledButtonsState(true, true, true, true);
              this.startAutoVisualization();
              document.getElementById("devices-dropdown").style.display =
                "none";
            }
          );
        } else {
          document.getElementById("devices-dropdown").style.display = "block";
          clearInterval(this.state.autoVisualizationIntervalID);
          selectedAddress = 0;
          this.setState({
            seriesBA: [{ data: [] }],
            seriesAB: [{ data: [] }],
            options: {
              ...this.state.options,
              title: {
                text: "",
                align: "center",
              },
              subtitle: {
                text: "",
                align: "center",
              },
            },
          });
        }
      }
    );
  };

  startAutoVisualization = () => {
    this.clearAllAnnotations();
    // Every 2 seconds start cycling through all the devices
    let autoVisualizationIntervalID = setInterval(() => {
      this.setDimmerActiveState(false);

      if (this.state.devices.length > 0) {
        this.getWaveData(this.state.devices[selectedAddress].address);
      }

      if (selectedAddress === this.state.devices.length - 1) {
        selectedAddress = 0;
      } else {
        selectedAddress++;
      }
    }, Constants.AUTO_VISUALIZATION_REFRESH_MS);

    // Save the interval ID as a state so it is possible to cancel it later
    this.setState({ autoVisualizationIntervalID: autoVisualizationIntervalID });
  };

  /// ---------------- Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  /// ---------------- Error Messages -----------------------------
  retrieveWarnings = () => {
    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "warnings", { mode: "cors", signal: this.state.controller.signal })
      .then((res) => res.json())
      .then((data) => {
        this.handleWarningMessages(data);
      })
      .catch((error) => {
        console.log("Warnings interrupted: ", error);
      });
  };

  handleWarningMessages = (errors) => {
    let errorMessages = [];

    if (
      errors.InitPicoNotFound ||
      errors.invertedAB ||
      errors.picoNotFound ||
      errors.monitorIPNotFound
    ) {
      // If at least one of the errors above ocurred, unhide the error message's container
      if (
        document.getElementById("message-list") !== undefined &&
        document.getElementById("message-list") !== null
      ) {
        document.getElementById("message-list").style.display = "block";
      }

      if (errors.InitPicoNotFound) {
        errorMessages.push(Strings.INIT_PICO_NOT_FOUND);
      }

      if (errors.invertedAB) {
        errorMessages.push(Strings.INVERTED_AB);
      }

      if (errors.picoNotFound) {
        errorMessages.push(Strings.PICO_NOT_FOUND);
      }

      if (errors.monitorIPNotFound) {
        errorMessages.push(Strings.MONITOR_IP_NOT_FOUND);
      }

      this.setState({ errorMessages: errorMessages });
    } else {
      if (
        document.getElementById("message-list") !== undefined &&
        document.getElementById("message-list") !== null
      ) {
        document.getElementById("message-list").style.display = "none";
      }

      this.setState({ errorMessages: [] });
    }
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    selectedAddress = 0;
    this.retrieveData();
    this.retrieveWarnings();
    this.setState({
      warningsIntervalID: setInterval(this.retrieveWarnings, 1000),
    });
    this.setDisabledButtonsState(true, true, true, true);
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.warningsIntervalID);
    clearInterval(this.state.autoVisualizationIntervalID);
    clearInterval(this.state.intervalID);
  }

  render() {
    let dropdownOptions = this.buildDevicesDropdownOptions(this.state.devices);

    return (
      <div style={screenStyle}>
        <Accordion id="message-list" styled style={accordionStyle}>
          <Accordion.Title
            style={accordionTitleStyle}
            active={this.state.accordionIndex === 1}
            index={1}
            onClick={this.handleAccordionClick}
          >
            <Icon name="exclamation triangle" />
            {Strings.DETECTED_PROBLEMS}
            <Icon name="dropdown" />
          </Accordion.Title>
          <Accordion.Content active={this.state.accordionIndex === 1}>
            <div style={accordionListItemsStyle}>
              <ul style={{ paddingLeft: 0 }}>
                {this.state.errorMessages.map((message) => (
                  <li key={message}>{message}</li>
                ))}
              </ul>
            </div>
          </Accordion.Content>
        </Accordion>

        <Grid columns={2} doubling>
          <Grid.Row>
            <Grid.Column width={4}>
              <Segment>
                <Divider horizontal style={dividerStyle}>
                  {Strings.VISUALIZATION}
                </Divider>
                <Form style={formStyle}>
                  <Form.Group widths="equal">
                    <Form.Checkbox
                      radio
                      label={Strings.AUTOMATIC}
                      checked={this.state.isAutomaticCheckboxChecked}
                      value={Constants.AUTOMATIC_CHECKBOX_VAL}
                      onChange={this.handleVisualizationTypeCheckboxChange}
                    />

                    <Form.Checkbox
                      radio
                      label={Strings.MANUAL}
                      checked={!this.state.isAutomaticCheckboxChecked}
                      value={Constants.MANUAL_CHECKBOX_VAL}
                      onChange={this.handleVisualizationTypeCheckboxChange}
                    />
                  </Form.Group>
                </Form>

                <Dropdown
                  id="devices-dropdown"
                  style={dropdownStyle}
                  placeholder={Strings.DEVICES}
                  fluid
                  selection
                  scrolling
                  options={dropdownOptions}
                  onChange={this.onDevicesDropdownChange}
                />
              </Segment>

              <Segment>
                <Divider horizontal style={dividerStyle}>
                  {Strings.CONTROLS}
                  <Popup
                    position="bottom center"
                    hoverable
                    pinned
                    trigger={<Icon name="info circle" color="teal" />}>
                    <Popup.Content style={{ paddingLeft: "1vw" }}>
                      <li>
                        <b>{Strings.PS_1}</b> {Strings.CONTROLS_POPUP_TEXT_2}
                      </li>
                      <li>
                        <b>{Strings.PS_2}</b> {Strings.CONTROLS_POPUP_TEXT}
                      </li>
                    </Popup.Content>
                  </Popup>
                </Divider>

                <Button.Group size="large" style={controlsButtonGroupStyle}>
                  <Button
                    id="play-btn"
                    onClick={this.handlePlayButtonClick}
                    icon="play"
                    color={this.state.playButtonColor} />

                  <Button
                    id="pause-btn"
                    onClick={this.handlePauseButtonClick}
                    icon="pause"
                    color={this.state.pauseButtonColor} />
                </Button.Group>
              </Segment>

              <Segment>
                <Divider horizontal style={dividerStyle}>
                  {Strings.CURSORS}
                </Divider>
                <Grid
                  columns="2"
                  centered
                  verticalAlign="middle"
                  celled
                  style={cursorsGridStyle}>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        id="amplitude-btn"
                        toggle
                        active={this.state.amplitudeActive}
                        onClick={this.handleAmplitudeButtonClick}
                        color="teal"
                        fluid>
                        {Strings.AMPLITUDE}
                      </Button>
                    </Grid.Column>
                    <Grid.Column textAlign="center" stretched>
                      <p id="wave-amplitude" style={cursorValuesStyle}>
                        {Strings.AMPLITUDE_PLACEHOLDER}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        id="time-interval-btn"
                        toggle
                        active={this.state.timeActive}
                        onClick={this.handleTimeButtonClick}
                        color="teal"
                        fluid>
                        &Delta;{Strings.TIME_INTERVAL}
                      </Button>
                    </Grid.Column>
                    <Grid.Column textAlign="center" stretched>
                      <p id="time-interval" style={cursorValuesStyle}>
                        {Strings.TIME_INTERVAL_PLACEHOLDER}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Grid.Column>
            <Grid.Column width={12}>
              <Segment textAlign="right" style={{ paddingBottom: "0" }}>

                <Label
                  as="a"
                  corner="right"
                  icon="info"
                  color="teal"
                  onClick={() => this.setState({ isRefenceImageModalOpen: true })} />

                <Chart
                  options={this.state.optionsBA}
                  series={this.state.seriesBA}
                  type="line"
                  height={UtilsInstance.adjustOscilloscopeChartHeight()} />

                <Chart
                  options={this.state.optionsAB}
                  series={this.state.seriesAB}
                  type="line"
                  height={UtilsInstance.adjustOscilloscopeChartHeight()} />

                <Dimmer active={this.state.isDimmerActive}>
                  <Loader>{Strings.LOADING}</Loader>
                </Dimmer>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Modal
          basic
          style={modalStyle}
          open={this.state.isRefenceImageModalOpen}
          onClose={() => this.setState({ isRefenceImageModalOpen: false })}>
          <Modal.Header style={modalHeaderStyle}>
            {Strings.MODAL_TITLE}
          </Modal.Header>
          <Modal.Content>
            <Grid columns="equal" centered>
              <Grid.Row>
                <Grid.Column textAlign="center" stretched>
                  <Segment>
                    <Header as="h3" dividing>
                      {Strings.STD_WAVE_FORM}
                    </Header>
                    <Image src={`${process.env.PUBLIC_URL}/images/forma-padrao.png`} />
                  </Segment>
                </Grid.Column>
                <Grid.Column textAlign="center" stretched>
                  <Segment>
                    <Header as="h3" dividing>
                      {Strings.LONG_CABLE_WAVE_FORM}
                    </Header>
                    <Image src={`${process.env.PUBLIC_URL}/images/cabo-longo.png`} />
                  </Segment>
                </Grid.Column>
                <Grid.Column textAlign="center" stretched>
                  <Segment>
                    <Header as="h3" dividing>
                      {Strings.EXCESS_TERMINATIOR_WAVE_FORM}
                    </Header>
                    <Image src={`${process.env.PUBLIC_URL}/images/excesso-terminador.png`} />
                  </Segment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column textAlign="center" stretched>
                  <Segment>
                    <Header as="h3" dividing>
                      {Strings.NO_SLAVE_WAVE_FORM}
                    </Header>
                    <Image src={`${process.env.PUBLIC_URL}/images/ausencia-escravo.png`} />
                  </Segment>
                </Grid.Column>
                <Grid.Column textAlign="center" stretched>
                  <Segment>
                    <Header as="h3" dividing>
                      {Strings.REFLECTION_WAVE_FORM}
                    </Header>
                    <Image src={`${process.env.PUBLIC_URL}/images/reflexao.png`} />
                  </Segment>
                </Grid.Column>
                <Grid.Column textAlign="center" stretched>
                  <Segment>
                    <Header as="h3" dividing>
                      {Strings.NO_TERMINATOR_WAVE_FORM}
                    </Header>
                    <Image src={`${process.env.PUBLIC_URL}/images/falta-terminador.png`} />
                  </Segment>
                </Grid.Column>
              </Grid.Row>
              <p style={moreInfoTextStyle}>{Strings.FOR_MORE_INFO_DP}</p>
            </Grid>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const formStyle = {
  marginTop: "-8pt",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "-10pt",
};

const dividerStyle = {
  marginTop: "-0.2vh",
};

const screenStyle = {
  marginTop: "0vh",
  marginBottom: "0vh",
  marginRight: "2vw",
  marginLeft: "2vw",
  textAlign: "center",
};

const dropdownStyle = {
  display: "none",
  marginBottom: "2vh",
  marginLeft: "auto",
  marginRight: "auto",
};

const cursorValuesStyle = {
  fontSize: "1.1em",
};

const modalStyle = {
  overflowY: "scroll",
};

const modalHeaderStyle = {
  textAlign: "center",
};

const moreInfoTextStyle = {
  margin: "2vh 2vw",
  fontSize: "1.2em",
};

const controlsButtonGroupStyle = {
  marginTop: "-4pt",
  marginBottom: "-4pt",
};

const cursorsGridStyle = {
  marginTop: "-5pt",
  marginBottom: "-4pt",
};

const accordionStyle = {
  color: "#9F3A38",
  backgroundColor: "#FFF6F6",
  display: "none",
  marginBottom: "2vh",
};

const accordionTitleStyle = {
  color: "#9F3A38",
};

const accordionListItemsStyle = {
  textAlign: "left",
  listStylePosition: "inside",
};

export default withRouter(Oscilloscope);
